import { Component, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-tab-group-meta',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template>
      <ng-content />
    </ng-template>
  `
})
export class TabGroupMetaComponent {
  @ViewChild(TemplateRef) public template!: TemplateRef<any>;
}
